import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// 언어별 모듈 import
import enManagePromotion from './en/managePromotion';
import koManagePromotion from './ko/managePromotion';
import enManageInquiry from './en/manageInquiry';
import koManageInquiry from './ko/manageInquiry';
import enManagePayment from './en/managePayment';
import koManagePayment from './ko/managePayment'
import enManageMail from './en/manageMail'; 
import koManageMail from './ko/manageMail'; 
import enManageSchedule from './en/manageSchedule'; 
import koManageSchedule from './ko/manageSchedule'; 
import enManageS3 from './en/manageS3';
import koManageS3 from './ko/manageS3'; 
import enManageGroundStation from './en/manageGroundStation';
import koManageGroundStation from './ko/manageGroundStation'; 
import enManageUser from './en/manageUser'; 
import koManageUser from './ko/manageUser'; 
import enDashboard from './en/dashboard';
import koDashboard from './ko/dashboard';
import enLanding from './en/landing';
import koLanding from './ko/landing';
import enFooter from './en/footer';
import koFooter from './ko/footer';
import enMyPage from './en/myPage';
import koMyPage from './ko/myPage';
import enMain from './en/main';
import koMain from './ko/main';
import enContactUs from './en/contactUs';
import koContactUs from './ko/contactUs';
import enManageContacts from './en/manageContacts';
import koManageContacts from './ko/manageContacts';
import enScheduleContact from './en/scheduleContact';
import koScheduleContact from './ko/scheduleContact';
import enContactProfile from './en/contactProfile';
import koContactProfile from './ko/contactProfile';
import enManageSpacecraft from './en/manageSpacecraft';
import koManageSpacecraft from './ko/manageSpacecraft';
import enFaq from './en/faq';
import koFaq from './ko/faq';
import enGetStarted from './en/getStarted';
import koGetStarted from './ko/getStarted';
import enPromotion from './en/promotion';
import koPromotion from './ko/promotion';
import enCalculator from './en/calculator';
import koCalculator from './ko/calculator';
import enPricing from './en/pricing';
import koPricing from './ko/pricing';
import enCommon from './en/common';
import koCommon from './ko/common';


// 리소스 구성
const resources = {
  en: {
    translation: {
      ...enCommon,
      ...enPricing,
      ...enCalculator,
      ...enPromotion,
      ...enGetStarted,
      ...enFaq,
      ...enManageSpacecraft,
      ...enContactProfile,
      ...enScheduleContact,
      ...enManageContacts,
      ...enContactUs,
      ...enMain,
      ...enMyPage,
      ...enFooter,
      ...enLanding,
      ...enDashboard,
      ...enManageUser,
      ...enManageGroundStation,
      ...enManageS3,
      ...enManageSchedule,
      ...enManageMail,
      ...enManagePayment,
      ...enManageInquiry,
      ...enManagePromotion,
    }
  },
  ko: {
    translation: {
      ...koCommon,
      ...koPricing,
      ...koCalculator,
      ...koPromotion,
      ...koGetStarted,
      ...koFaq,
      ...koManageSpacecraft,
      ...koContactProfile,
      ...koScheduleContact,
      ...koManageContacts,
      ...koContactUs,
      ...koMain,
      ...koMyPage,
      ...koFooter,
      ...koLanding,
      ...koDashboard,
      ...koManageUser,
      ...koManageGroundStation,
      ...koManageS3,
      ...koManageSchedule,
      ...koManageMail,
      ...koManagePayment,
      ...koManageInquiry,
      ...koManagePromotion,
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',           // 기본 언어
  fallbackLng: 'en', 
  interpolation: {
    escapeValue: false
  }
});

export default i18n;